import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides } from '../../../utils/overrides';
const Spacer = _ref => {
  let {
    x = 0,
    y = 0,
    overrides: overridesProp,
    className: classNameProp
  } = _ref;
  // Overrides
  const override = getOverrides(overridesProp, Spacer.overrides);

  // Classes
  const rootClassName = classnames(classNameProp);
  const style = {
    margin: `${y * 4}px ${x * 4}px`
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: rootClassName,
    style: style
  }, override.root));
};
Spacer.overrides = ['root'];
process.env.NODE_ENV !== "production" ? Spacer.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number
} : void 0;
export default /*#__PURE__*/memo(Spacer);